import { useTheme } from 'styled-components';

import { MessageOptions, MessageType } from '@dreryk/react-components';

export const useOptions = (): MessageOptions<{
   [MessageType.NEGATIVE]: MessageType;
   [MessageType.POSITIVE]: MessageType;
}> => {
   const theme = useTheme();

   return {
      [MessageType.NEGATIVE]: {
         color: theme.error,
         backgroundColor: theme.errorLighter,
         labelColor: theme.textBody,
      },
      [MessageType.POSITIVE]: {
         color: theme.success,
         backgroundColor: theme.successLighter,
         labelColor: theme.successDark,
      },
   };
};
